"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHtmlFromAccordion = void 0;
var react_1 = __importDefault(require("react"));
var server_1 = __importDefault(require("react-dom/server"));
var uuid_1 = require("uuid");
var Widgets_1 = require("Public/Widgets");
var createHtmlFromAccordion = function (token, options) {
    var _a;
    return server_1.default.renderToString(react_1.default.createElement(Widgets_1.Accordion, {
        id: (0, uuid_1.v4)(),
        heading: options.renderTokens(token.heading),
        body: options.renderTokens(token.body),
        backgroundImageUrl: token.backgroundImageUrl,
        isPrintMode: (_a = options.isPrintMode) !== null && _a !== void 0 ? _a : false,
    }));
};
exports.createHtmlFromAccordion = createHtmlFromAccordion;
